module.exports = __webpack_public_path__ + "media/images/bank_images/bgn-e2d9fb081564bfe8eae1c07fc2bbdee9.png";